import { Injectable } from '@angular/core';
import { NetworkManager } from 'src/app/managers/network/network.manager';
import { HttpHeaders } from '@angular/common/http';
import { RequestField } from 'src/app/enums/network/request/requestField.enum';
import { CQWebappApi } from 'src/app/enums/network/request/cqwebapp/cqwebappApi.enum';

@Injectable({
  providedIn: 'root',
})
export class ServiceRequest {
  constructor(private network: NetworkManager) {}

  /**
   *
   * @param token
   * @param siteId
   */
  list(token: string, siteId: number, enabled: number) {
    let url = this.network.CodaQApi() + CQWebappApi.SERVICE_LIST;

    const headers = new HttpHeaders().append(RequestField.TOKEN, token);

    const form = new URLSearchParams();
    form.set(RequestField.SITE_ID, siteId.toString());
    form.set(RequestField.ENABLED, enabled.toString());

    return this.network.http().put(url, form.toString(), { headers });
  }

  /**
   *
   * @param token
   * @param siteId
   */
  getServiceMin(token: string, siteId: number) {
    let url = this.network.CodaQApi() + CQWebappApi.SERVICE_MIN_LIST;

    const headers = new HttpHeaders().append(RequestField.TOKEN, token);

    const form = new URLSearchParams();

    form.set(RequestField.SITE_ID, siteId.toString());

    return this.network.http().put(url, form.toString(), { headers });
  }

  /**
   *
   * @param token
   * @param siteId
   * @param serviceId
   */
  getDetail(token: string, siteId: number, serviceId: number) {
    let url = this.network.CodaQApi() + CQWebappApi.SERVICE_DETAIL;

    const headers = new HttpHeaders().append(RequestField.TOKEN, token);

    const form = new URLSearchParams();
    form.set(RequestField.SITE_ID, siteId.toString());
    form.set(RequestField.SERVICE_ID, serviceId.toString());

    return this.network.http().put(url, form.toString(), { headers });
  }

  /**
   *
   * @param token
   */
  getCategory(token: string) {
    let url = this.network.CodaQApi() + CQWebappApi.SERVICE_CATEGORY;

    const headers = new HttpHeaders().append(RequestField.TOKEN, token);

    return this.network.http().put(url, null, { headers });
  }

  /**
   *
   * @param token
   * @param serviceId
   */
  calendar(token: string, serviceId: number) {
    let url = this.network.CodaQApi() + CQWebappApi.SERVICE_CALENDAR;

    const headers = new HttpHeaders().append(RequestField.TOKEN, token);

    const form = new URLSearchParams();
    form.set(RequestField.SERVICE_ID, serviceId.toString());

    return this.network.http().put(url, form.toString(), { headers });
  }

  /**
   *
   * @param token
   * @param serviceId
   * @param calendarId
   * @param dow
   * @param open
   * @param close
   */
  updateCalendar(
    token: string,
    serviceId: number,
    calendarId: number,
    dow: number,
    open: string,
    close: string,
  ) {
    let url = this.network.CodaQApi() + CQWebappApi.SERVICE_CALENDAR_UPDATE;

    const headers = new HttpHeaders().append(RequestField.TOKEN, token);

    const form = new URLSearchParams();
    form.set(RequestField.SERVICE_ID, serviceId.toString());
    form.set(RequestField.CALENDAR_ID, calendarId.toString());
    form.set(RequestField.CALENDAR_DOW, dow.toString());
    form.set(RequestField.CALENDAR_OPEN, open.toString());
    form.set(RequestField.CALENDAR_CLOSE, close.toString());

    return this.network.http().put(url, form.toString(), { headers });
  }

  /**
   *
   * @param token
   * @param serviceId
   * @param calendarId
   * @param timeId
   */
  deleteTime(
    token: string,
    serviceId: number,
    calendarId: number,
    timeId: number,
  ) {
    let url = this.network.CodaQApi() + CQWebappApi.SERVICE_CALENDAR_DELETE;

    const headers = new HttpHeaders().append(RequestField.TOKEN, token);

    const form = new URLSearchParams();
    form.set(RequestField.SERVICE_ID, serviceId.toString());
    form.set(RequestField.CALENDAR_ID, calendarId.toString());
    form.set(RequestField.TIME_ID, timeId.toString());

    return this.network.http().put(url, form.toString(), { headers });
  }

  /**
   *
   * @param token
   * @param serviceId
   * @param data
   */
  create(token: string, siteId: number, data: string) {
    let url = this.network.CodaQApi() + CQWebappApi.SERVICE_CREATE;

    const headers = new HttpHeaders().append(RequestField.TOKEN, token);

    const form = new URLSearchParams();
    form.set(RequestField.SITE_ID, siteId.toString());
    form.set(RequestField.DATA, data.toString());

    return this.network.http().post(url, form.toString(), { headers });
  }

  update(token: string, siteId: number, serviceId: number, data: string) {
    let url = this.network.CodaQApi() + CQWebappApi.SERVICE_UPDATE;

    const headers = new HttpHeaders().append(RequestField.TOKEN, token);

    const form = new URLSearchParams();
    form.set(RequestField.SITE_ID, siteId.toString());
    form.set(RequestField.SERVICE_ID, serviceId.toString());
    form.set(RequestField.DATA, data.toString());

    return this.network.http().put(url, form.toString(), { headers });
  }

  /**
   *
   * @param token
   * @param serviceId
   * @param calendarId
   * @param timeId
   * @param enabled
   */
  calendarStatus(
    token: string,
    serviceId: number,
    calendarId: number,
    timeId: number,
    enabled: number,
  ) {
    let url = this.network.CodaQApi() + CQWebappApi.SERVICE_CALENDAR_STATUS;

    const headers = new HttpHeaders().append(RequestField.TOKEN, token);

    const form = new URLSearchParams();
    form.set(RequestField.SERVICE_ID, serviceId.toString());
    form.set(RequestField.CALENDAR_ID, calendarId.toString());
    form.set(RequestField.TIME_ID, timeId.toString());
    form.set(RequestField.ENABLED, enabled.toString());

    return this.network.http().put(url, form.toString(), { headers });
  }

  /**
   *
   * @param token
   * @param serviceId
   */
  changeStatus(token: string, serviceId: number) {
    let url = this.network.CodaQApi() + CQWebappApi.SERVICE_CHANGE_STATUS;

    const headers = new HttpHeaders().append(RequestField.TOKEN, token);

    const form = new URLSearchParams();

    form.set(RequestField.SERVICE_ID, serviceId.toString());

    return this.network.http().put(url, form.toString(), { headers });
  }
}
